import { c as _c } from "react/compiler-runtime";
import Script from 'next/script';
export function Digioh() {
  const $ = _c(1);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = <Script id="digioh" strategy="afterInteractive" src="https://www.lightboxcdn.com/vendor/0d1ee324-9c1b-4837-88cd-a5a4a387633a/lightbox_speed.js" />;
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  return t0;
}